import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import AttorneyService from '@services/AttorneyService';

class AttorneyAutoSuggestInsideApplication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultAttorney || '',
      suggestions: [],
    };
  }

  componentDidMount() {
    const { defaultAttorney } = this.props;
    this.setState({ value: defaultAttorney || '' });
  }

  componentDidUpdate(prevProps) {
    const { defaultAttorney } = this.props;
    if (prevProps.defaultAttorney !== defaultAttorney) {
      this.setState({ value: defaultAttorney || '' });
    }
  }

  getSuggestionValue = (suggestion) => {
    const { selectedAttorney, selectedAttorneyName } = this.props;
    selectedAttorney(suggestion.publicId);
    selectedAttorneyName(suggestion.displayName);
    return suggestion.displayName;
  };

  static renderSuggestion = (suggestion) => <span>{suggestion.displayName}</span>;

  onChange = (event, { newValue }) => {
    const { selectedAttorney, selectedAttorneyName } = this.props;
    this.setState({ value: newValue });

    if (!newValue) {
      selectedAttorneyName('');
      selectedAttorney(null);
    }
  };

  onSuggestionsFetchRequested = ({ value }) => {
    AttorneyService.autoSuggest(value).then((response) => {
      this.setState({ suggestions: response.data.data });
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: 'Search Attorney...',
      value,
      onChange: this.onChange,
    };

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={AttorneyAutoSuggestInsideApplication.renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}

AttorneyAutoSuggestInsideApplication.propTypes = {
  selectedAttorney: PropTypes.func.isRequired,
  selectedAttorneyName: PropTypes.func.isRequired,
  defaultAttorney: PropTypes.string,
};

AttorneyAutoSuggestInsideApplication.defaultProps = {
  defaultAttorney: '',
};

export default AttorneyAutoSuggestInsideApplication;
